module.exports = __webpack_public_path__ + "img/Sound1.b6132b66.png";